import Tippy from "@tippyjs/react";

interface CustomToolTipProps {
  children: any;
  label: string;
}

const CustomToolTip = ({ children, label }: CustomToolTipProps) => {
  return (
    <Tippy className="tool-tip-style" content={<span>{label}</span>}>
      {children}
    </Tippy>
  );
};

export default CustomToolTip;
